import { render } from "./TriviaGame.vue?vue&type=template&id=6350adb0&scoped=true"
import script from "./TriviaGame.vue?vue&type=script&lang=js"
export * from "./TriviaGame.vue?vue&type=script&lang=js"

import "./TriviaGame.vue?vue&type=style&index=0&id=6350adb0&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6350adb0"]])

export default __exports__